/**
 * AquaDog — comportamientos de la tienda.
 * Script clasico (sin modulos) para no depender del importmap del tema.
 * Todo se re-inicializa en shopify:section:load para que funcione en el editor.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * Utilidades
   * ------------------------------------------------------------------ */

  var moneyFormat = (window.AQ_MONEY_FORMAT || '{{amount_with_comma_separator}} €');

  function formatMoney(cents, format) {
    var fmt = format || moneyFormat;
    var value = Number(cents);
    if (isNaN(value)) return '';

    function number(num, precision, thousands, decimal) {
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var tail = parts[1] ? decimal + parts[1] : '';
      return head + tail;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':
          return number(value, 2, ',', '.');
        case 'amount_no_decimals':
          return number(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return number(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return number(value, 0, '.', ',');
        case 'amount_with_space_separator':
          return number(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return number(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return number(value, 2, "'", '.');
        default:
          return number(value, 2, '.', ',');
      }
    });
  }

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function once(el, key) {
    if (!el || el.dataset['aqInit' + key] === '1') return false;
    el.dataset['aqInit' + key] = '1';
    return true;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait || 120);
    };
  }

  /* ------------------------------------------------------------------ *
   * 1. Caja de compra: packs + variantes
   * ------------------------------------------------------------------ */

  function initBuyBox(root) {
    var box = root.matches && root.matches('[data-aq-buybox]') ? root : $('[data-aq-buybox]', root);
    if (!box || !once(box, 'BuyBox')) return;

    var variants = [];
    var dataEl = $('[data-aq-variants]', box);
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var packs = $$('[data-aq-pack]', box);
    var optionsHolder = $('[data-aq-options]', box);
    var selects = $$('[data-aq-option]', box);
    var idInput = $('input[name="id"]', box);
    var qtyInput = $('[data-aq-qty]', box);
    var packProp = $('[data-aq-pack-prop]', box);
    var savingsWrap = $('[data-aq-savings]', box);
    var savingsAmount = $('[data-aq-savings-amount]', box);
    var atcButton = $('[data-aq-atc]', box);
    var soldOutLabel = box.dataset.soldOutText || 'Agotado';
    var atcLabel = box.dataset.atcText || 'Agregar al carrito';

    /* --- variante seleccionada --- */

    function currentOptions() {
      return selects.map(function (s) {
        return s.value;
      });
    }

    function findVariant() {
      var opts = currentOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(v.options[j]) !== String(opts[j])) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    /* --- disponibilidad: marca las opciones sin stock --- */

    function refreshAvailability() {
      selects.forEach(function (select, index) {
        var opts = currentOptions();
        $$('option', select).forEach(function (option) {
          var probe = opts.slice();
          probe[index] = option.value;
          var exists = variants.some(function (v) {
            for (var j = 0; j < probe.length; j++) {
              if (String(v.options[j]) !== String(probe[j])) return false;
            }
            return v.available;
          });
          option.dataset.aqUnavailable = exists ? 'false' : 'true';
          var base = option.dataset.aqLabel || option.textContent.replace(/\s*—\s*Agotado$/, '').trim();
          option.dataset.aqLabel = base;
          option.textContent = exists ? base : base + ' — Agotado';
        });
      });
    }

    /* --- precios de cada pack --- */

    function selectedPack() {
      return (
        packs.filter(function (p) {
          return p.dataset.aqSelected === 'true';
        })[0] || packs[0]
      );
    }

    function packUnitPrice(variant) {
      return variant ? Number(variant.price) : Number(box.dataset.basePrice || 0);
    }

    function packComparePrice(variant) {
      var compare = variant && variant.compare_at_price ? Number(variant.compare_at_price) : 0;
      return compare > 0 ? compare : packUnitPrice(variant);
    }

    function refreshPrices(variant) {
      var unit = packUnitPrice(variant);
      var compareUnit = packComparePrice(variant);

      packs.forEach(function (pack) {
        var qty = Number(pack.dataset.aqQty || 1);
        var discount = Number(pack.dataset.aqDiscount || 0);
        var fixed = Number(pack.dataset.aqFixedPrice || 0);
        var total = fixed > 0 ? fixed : Math.round(unit * qty * (1 - discount / 100));
        var compare = compareUnit * qty;

        pack.dataset.aqTotal = String(total);
        pack.dataset.aqCompare = String(compare);

        var totalEl = $('[data-aq-pack-total]', pack);
        var compareEl = $('[data-aq-pack-compare]', pack);
        var unitEl = $('[data-aq-pack-unit]', pack);

        if (totalEl) totalEl.textContent = formatMoney(total);
        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = compare <= total;
        }
        if (unitEl) unitEl.textContent = formatMoney(Math.round(total / qty));
      });

      refreshSavings();
    }

    function refreshSavings() {
      var pack = selectedPack();
      if (!pack) return;
      var total = Number(pack.dataset.aqTotal || 0);
      var compare = Number(pack.dataset.aqCompare || 0);
      var saved = compare - total;

      if (savingsWrap) savingsWrap.hidden = saved <= 0;
      if (savingsAmount) savingsAmount.textContent = formatMoney(saved);
    }

    /* --- sincroniza el formulario --- */

    function syncForm() {
      var variant = findVariant();
      var pack = selectedPack();

      if (idInput && variant) idInput.value = variant.id;
      if (qtyInput && pack) qtyInput.value = pack.dataset.aqQty || '1';

      if (packProp && pack) {
        var label = pack.dataset.aqLabel || '';
        packProp.value = label;
        packProp.disabled = !label;
      }

      if (atcButton) {
        var available = variant && variant.available;
        atcButton.disabled = !available;
        var textEl = $('[data-aq-atc-text]', atcButton);
        if (textEl) textEl.textContent = available ? atcLabel : soldOutLabel;
      }

      refreshPrices(variant);
      updateGalleryForVariant(variant);

      box.dispatchEvent(
        new CustomEvent('aq:variant', { bubbles: true, detail: { variant: variant, pack: pack } })
      );
    }

    /* --- galeria: salta a la imagen de la variante --- */

    function updateGalleryForVariant(variant) {
      if (!variant || !variant.featured_media_id) return;
      var gallery = $('[data-aq-gallery]');
      if (!gallery) return;
      var slide = $('[data-aq-media-id="' + variant.featured_media_id + '"]', gallery);
      if (slide && typeof gallery.aqGoTo === 'function') {
        gallery.aqGoTo(Number(slide.dataset.aqIndex || 0));
      }
    }

    /* --- eventos --- */

    packs.forEach(function (pack) {
      pack.addEventListener('click', function (event) {
        if (event.target.closest('[data-aq-options]')) return;
        packs.forEach(function (p) {
          p.dataset.aqSelected = p === pack ? 'true' : 'false';
          var radio = $('[data-aq-radio]', p);
          if (radio) radio.checked = p === pack;
        });
        if (optionsHolder) {
          var slot = $('[data-aq-options-slot]', pack);
          if (slot && optionsHolder.parentNode !== slot) slot.appendChild(optionsHolder);
        }
        syncForm();
      });

      pack.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          pack.click();
        }
      });
    });

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        refreshAvailability();
        syncForm();
      });
    });

    refreshAvailability();
    syncForm();
  }

  /* ------------------------------------------------------------------ *
   * 2. Galeria de producto
   * ------------------------------------------------------------------ */

  function initGallery(root) {
    $$('[data-aq-gallery]', root).forEach(setupGallery);
    if (root.matches && root.matches('[data-aq-gallery]')) setupGallery(root);
  }

  function setupGallery(gallery) {
    if (!once(gallery, 'Gallery')) return;

    var track = $('[data-aq-gallery-track]', gallery);
    var slides = $$('[data-aq-media-id]', gallery);
    var thumbs = $$('[data-aq-thumb]', gallery);
    var dotsWrap = $('[data-aq-gallery-dots]', gallery);
    var index = 0;

    if (!track || !slides.length) return;

    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'aq-dots__dot';
        dot.setAttribute('aria-label', 'Imagen ' + (i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function setActive(i) {
      index = i;
      thumbs.forEach(function (t, ti) {
        t.dataset.aqActive = ti === i ? 'true' : 'false';
      });
      dots.forEach(function (d, di) {
        d.dataset.aqActive = di === i ? 'true' : 'false';
      });
    }

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    gallery.aqGoTo = goTo;

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    track.addEventListener(
      'scroll',
      debounce(function () {
        var closest = 0;
        var min = Infinity;
        slides.forEach(function (slide, i) {
          var delta = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (delta < min) {
            min = delta;
            closest = i;
          }
        });
        setActive(closest);
      }, 80)
    );

    setActive(0);
  }

  /* ------------------------------------------------------------------ *
   * 3. Carrusel generico (UGC, mini resenas)
   * ------------------------------------------------------------------ */

  function initCarousels(root) {
    $$('[data-aq-carousel]', root).forEach(setupCarousel);
    if (root.matches && root.matches('[data-aq-carousel]')) setupCarousel(root);
  }

  function setupCarousel(carousel) {
    if (!once(carousel, 'Carousel')) return;

    var track = $('[data-aq-carousel-track]', carousel);
    var dotsWrap = $('[data-aq-carousel-dots]', carousel);
    var prev = $('[data-aq-carousel-prev]', carousel);
    var next = $('[data-aq-carousel-next]', carousel);
    if (!track) return;

    var items = $$(':scope > *', track);
    if (!items.length) return;

    function perView() {
      if (items.length < 2) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return Math.max(1, Math.round((track.clientWidth + gap) / (items[0].offsetWidth + gap)));
    }

    function pages() {
      return Math.max(1, Math.ceil(items.length / perView()));
    }

    var dots = [];

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var total = pages();
      if (total < 2) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i < total; i++) {
        (function (i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'aq-dots__dot';
          dot.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        })(i);
      }
      syncDots();
    }

    function syncDots() {
      if (!dots.length) return;
      var current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, i) {
        d.dataset.aqActive = i === current ? 'true' : 'false';
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', debounce(syncDots, 80));
    window.addEventListener('resize', debounce(buildDots, 200));
    buildDots();
  }

  /* ------------------------------------------------------------------ *
   * 4. Slider antes / despues
   * ------------------------------------------------------------------ */

  function initCompare(root) {
    $$('[data-aq-compare]', root).forEach(setupCompare);
    if (root.matches && root.matches('[data-aq-compare]')) setupCompare(root);
  }

  function setupCompare(el) {
    if (!once(el, 'Compare')) return;

    var handle = $('[data-aq-compare-handle]', el);
    var dragging = false;

    function setPosition(clientX) {
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      el.style.setProperty('--aq-compare-pos', pct + '%');
      if (handle) handle.setAttribute('aria-valuenow', String(Math.round(pct)));
    }

    function start(event) {
      dragging = true;
      el.dataset.aqDragging = 'true';
      move(event);
    }

    function move(event) {
      if (!dragging) return;
      var x = event.touches ? event.touches[0].clientX : event.clientX;
      setPosition(x);
      if (event.cancelable && event.touches) event.preventDefault();
    }

    function end() {
      dragging = false;
      el.dataset.aqDragging = 'false';
    }

    el.addEventListener('mousedown', start);
    el.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);

    el.addEventListener('click', function (event) {
      if (dragging) return;
      setPosition(event.clientX);
    });

    if (handle) {
      handle.addEventListener('keydown', function (event) {
        var current = parseFloat(el.style.getPropertyValue('--aq-compare-pos')) || 50;
        if (event.key === 'ArrowLeft') {
          el.style.setProperty('--aq-compare-pos', Math.max(2, current - 4) + '%');
          event.preventDefault();
        }
        if (event.key === 'ArrowRight') {
          el.style.setProperty('--aq-compare-pos', Math.min(98, current + 4) + '%');
          event.preventDefault();
        }
      });
    }
  }

  /* ------------------------------------------------------------------ *
   * 5. Barra sticky de compra
   * ------------------------------------------------------------------ */

  function initStickyBar(root) {
    var bar = $('[data-aq-sticky]', root) || (root.matches && root.matches('[data-aq-sticky]') ? root : null);
    if (!bar || !once(bar, 'Sticky')) return;

    var target = $('[data-aq-sticky-anchor]');
    if (!target || !('IntersectionObserver' in window)) {
      bar.dataset.aqVisible = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.dataset.aqVisible = entry.isIntersecting ? 'false' : 'true';
        });
      },
      { rootMargin: '0px 0px -60% 0px' }
    );

    observer.observe(target);

    $$('[data-aq-sticky-cta]', bar).forEach(function (cta) {
      cta.addEventListener('click', function (event) {
        var anchor = $('[data-aq-sticky-anchor]');
        if (!anchor) return;
        event.preventDefault();
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        anchor.dataset.aqPulse = 'true';
        setTimeout(function () {
          delete anchor.dataset.aqPulse;
        }, 1400);
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 6. "Mostrar mas" en resenas
   * ------------------------------------------------------------------ */

  function initShowMore(root) {
    $$('[data-aq-showmore]', root).forEach(function (btn) {
      if (!once(btn, 'ShowMore')) return;
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-aq-showmore-scope]');
        if (!wrap) return;
        var hidden = $$('[data-aq-hidden="true"]', wrap).slice(0, Number(btn.dataset.aqStep || 6));
        hidden.forEach(function (item) {
          item.dataset.aqHidden = 'false';
        });
        if (!$('[data-aq-hidden="true"]', wrap)) btn.hidden = true;
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 7. Aparición al hacer scroll
   * ------------------------------------------------------------------ */

  var revealObserver = null;

  function getRevealObserver() {
    if (revealObserver) return revealObserver;
    if (!('IntersectionObserver' in window)) return null;

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.dataset.aqIn = 'true';
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    return revealObserver;
  }

  function initReveal(root) {
    var targets = $$('.aq-reveal, .aq-stagger', root);
    if (root.matches && root.matches('.aq-reveal, .aq-stagger')) targets.push(root);

    var observer = getRevealObserver();

    targets.forEach(function (el) {
      if (!once(el, 'Reveal')) return;

      // Sin IntersectionObserver (o con movimiento reducido) se muestra sin más.
      if (!observer) {
        el.dataset.aqIn = 'true';
        return;
      }

      observer.observe(el);
    });
  }

  /* ------------------------------------------------------------------ *
   * 8. Contador regresivo suave (sin fechas exactas)
   * ------------------------------------------------------------------ */

  function initCountdown(root) {
    $$('[data-aq-countdown]', root).forEach(function (el) {
      if (!once(el, 'Countdown')) return;
      var minutes = Number(el.dataset.aqCountdown || 15);
      var end = Date.now() + minutes * 60 * 1000;

      function tick() {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000);
        var s = Math.floor((left % 60000) / 1000);
        el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        if (left > 0) setTimeout(tick, 1000);
      }

      tick();
    });
  }

  /* ------------------------------------------------------------------ *
   * Arranque
   * ------------------------------------------------------------------ */

  function initAll(root) {
    var scope = root || document;
    var steps = [initReveal, initGallery, initBuyBox, initCarousels, initCompare, initStickyBar, initShowMore, initCountdown];

    // Cada bloque va aislado: si uno falla, el resto de la página sigue funcionando.
    steps.forEach(function (step) {
      try {
        step(scope);
      } catch (error) {
        console.error('[AquaDog]', step.name, error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.AQ = { init: initAll, formatMoney: formatMoney };
})();
